import { useRef } from 'react';
import { toast } from 'react-toastify';
import Notification from 'src/components/Notification';

const useNotification = () => {
  const toastCreated = useRef('');

  const onNotificationClose = () => {
    toastCreated.current = '';
  };

  const showNotification = (label: string, active?: boolean) => {
    if (toastCreated.current === label) {
      toast.update(label, {
        render: () => <Notification label={label} active={active} />,
        position: 'top-left',
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: false,
        onClose: onNotificationClose,
      });
      return;
    }

    toast.dark(<Notification label={label} active={active} />, {
      toastId: label,
      position: 'top-left',
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: false,
      onClose: onNotificationClose,
    });
    toastCreated.current = label;
  };
  return { showNotification };
};

export default useNotification;
